import { useState, useEffect } from 'react';
import { META, ROUTES } from './data';

// Halcyon & Vale — minimal museum-wall header with brand on its own line above nav.
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`sticky top-0 z-40 bg-[#F4F1EA] transition-all duration-700 ${scrolled ? 'border-b border-[#0A0A0A]/10 py-3' : 'py-6'}`}>
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14">
        <div className="flex items-baseline justify-between gap-6">
          <button onClick={() => setPage('home')} className="text-left" data-testid="art-logo">
            <span className="font-serif text-2xl lg:text-3xl text-[#0A0A0A]" dangerouslySetInnerHTML={{ __html: META.brand }} />
            <span className="font-mono text-[9px] tracking-[0.4em] uppercase text-[#0A0A0A]/45 block leading-tight mt-0.5">{META.tagline} · est. {META.est}</span>
          </button>
          <nav className="hidden lg:flex items-center gap-10">
            {ROUTES.map(r => (
              <button key={r.id} onClick={() => setPage(r.id)} data-testid={`art-nav-${r.id}`}
                className={`font-serif italic text-lg transition-colors ${page === r.id ? 'text-[#B53024]' : 'text-[#0A0A0A]/55 hover:text-[#0A0A0A]'}`}>
                {r.label}
              </button>
            ))}
          </nav>
          <div className="hidden md:flex items-center gap-4">
            <button onClick={() => setPage('visit')} className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B53024] border-b border-[#B53024] hover:text-[#0A0A0A] hover:border-[#0A0A0A]" data-testid="art-cta-appointment">
              Book a viewing
            </button>
          </div>
        </div>
        {/* Distinctive: thin horizontal "wall" line under nav with three section markers */}
        <div className="hidden md:flex items-center mt-5 gap-3 text-[9px] font-mono tracking-[0.35em] uppercase text-[#0A0A0A]/35">
          <span>Programme</span><span className="flex-1 h-px bg-[#0A0A0A]/15" />
          <span>Catalogue</span><span className="flex-1 h-px bg-[#0A0A0A]/15" />
          <span>Visit</span>
        </div>
      </div>
    </header>
  );
}
